/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    },

    'blog': {
      init: function () {

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  // $('.hamburger-menu').on('click', function(){
  //   $('.resp-menu-container').toggleClass('show');
  // }) ;

  $('.trigpop').click(function(e) {
    e.preventDefault();
    $('#sr-res-root').click();
  });
  $(document.body).on('click', '.reservation-button' ,function(){
    if(!$(this).is('#resbtndnu')) { 
      window.location.href = "/reservations";
    }
  });



  if (jQuery(window).width() < 1038) {
    var winHeight = window.innerHeight - 127;
  } else {
    var winHeight = window.innerHeight - 78;
  }

  $(".home .hero-carousel__slide").css("height",winHeight + "px");
 





  jQuery('.cta-container a').click(function(e) {
    
  
  if(jQuery(this).attr('href') == 'https://thewolseley.com#menuscroll') {
    e.preventDefault();
    jQuery('html, body').animate({
                      scrollTop: (jQuery(".dining-times").offset().top - 70)
                  }, 1000);
  }
  
  });


  if(jQuery('.enquiry-form').length && jQuery('.enquiry-form .gform_confirmation_wrapper').length) {
    window.dataLayer = window.dataLayer || [];
  	window.dataLayer.push({
		'event': 'pdr_request'
  	});
  }


  if(jQuery('p#subscribe_to_newsletter_field').length) {
    jQuery('p#subscribe_to_newsletter_field').text('Sign up to receive exclusive offers and the latest news for product launches from The Wolseley Collection, restaurant news, events and more.');
  }







  if ( document.location.href.indexOf('afternoon-tea') > -1 ) {
    console.log('mmm afternoon tea');
    $('#sevenrooms-form').bind('DOMSubtreeModified', function(e) {
      console.log('foundit');
      if (e.target.innerHTML.length > 0) {
        if(jQuery('#sevenrooms-form').attr('src') !== 'https://www.sevenrooms.com/reservations/wolseleylondon/fb?client_id=e59eb23a453dbcaeb6929deb85432752280be7690749dc72ec7ec178935c6d51447362c84daabbc6cc9cb579bcbe3babad09e696e076869c80d692218a237b75') {
          jQuery('#sevenrooms-form').attr('src', 'https://www.sevenrooms.com/reservations/wolseleylondon/fb?client_id=e59eb23a453dbcaeb6929deb85432752280be7690749dc72ec7ec178935c6d51447362c84daabbc6cc9cb579bcbe3babad09e696e076869c80d692218a237b75');
        }
      }
    });

  }



})(jQuery); // Fully reference jQuery after this point.
